import {
	Capabilities,
	CapabilityService,
	PermissionService,
	RbacActions,
	type CapabilityAlias,
	type RbacActionDefinition,
} from '@supply-mover-2-0/shared';

/**
 * The Inbox (PD-17547): the person's own feed of calls, texts, chat and email.
 * One page with no tabs (Chris, 10/25/26): Call History is a report under
 * Reporting › Communications Reports, and Live Calls is a page of its own.
 */
export const INBOX_PATH = '/inbox';

/** Live Calls (PD-17548): calls in progress, for those who watch the phones. */
export const LIVE_CALLS_PATH = '/live-calls';

export interface InboxAccessChecksModel {
	can: (action: RbacActionDefinition) => boolean;
	allows: (capability: CapabilityAlias | ReadonlyArray<CapabilityAlias>) => boolean;
}

const defaultChecks: InboxAccessChecksModel = {
	can: (action) => PermissionService.can(action),
	allows: (capability) => CapabilityService.allows(capability),
};

/**
 * Whether the person can open the Inbox: the inbox action and the softphone
 * or SMS capability (it carries softphone calls and texts). The menu entry,
 * the route and every link to the Inbox use this rule.
 */
export function canOpenInbox(checks: InboxAccessChecksModel = defaultChecks): boolean {
	return (
		checks.allows([Capabilities.SOFTPHONE, Capabilities.SMS]) &&
		checks.can(RbacActions.COMMUNICATIONS.INBOX.VIEW)
	);
}

/**
 * Whether the person can open Live Calls: `phone:live_calls:view` and the
 * softphone capability, the same rule its snapshot endpoint enforces.
 */
export function canOpenLiveCalls(checks: InboxAccessChecksModel = defaultChecks): boolean {
	return (
		checks.allows(Capabilities.SOFTPHONE) &&
		checks.can(RbacActions.PHONE.LIVE_CALLS.VIEW)
	);
}
